import { deleteApi, getApi, patchApi, postApi } from "./apiService";

export const createProduct = async (body) => {
    return await postApi("/mp/product/create", body)
}

export const updateProduct = async (id, body) => {
    return await patchApi(`/mp/product/update/${id}`, body)
}

export const updateStatus = async (id, body) => {
    return await patchApi(`/mp/product/status/${id}`, body)
}

export const fetchProductsByFilter = async (queryParams = {}) => {
    const queryString = new URLSearchParams(queryParams).toString();
    return await getApi(`/mp/product/get-by-filter?${queryString}`);
};


export const deleteProduct = async (id) => {
    return await deleteApi(`/mp/product/delete/${id}`)
}